// 使用新的 mapSystem 架構
import { drawD3Map as drawD3MapModular, drawBackgroundMap as drawBackgroundMapModular } from '@/views/situationRoom/utils/mapSystem/core/drawD3Map'

// 為了向後兼容，保留原始函式名稱
export function drawD3Map (container, vm, siteData = []) {
  return drawD3MapModular(container, vm, siteData)
}

export function drawBackgroundMap (container) {
  return drawBackgroundMapModular(container)
}
